import { useState } from "react";
import { XCircle } from "lucide-react";
import DeskConfirm from "@/components/crm/DeskConfirm";

/** AviReasonModal — confirmation avec motif obligatoire (≥ 3 car.) — R2 (iter393). onConfirm({ reason }). */
export default function AviReasonModal({ title = "Confirmer", description = "", confirmLabel = "Confirmer", onClose, onConfirm }) {
  const [saving, setSaving] = useState(false);
  const submit = async (reason) => {
    if (saving) return;
    setSaving(true);
    try { await onConfirm({ reason }); } finally { setSaving(false); }
  };
  return (
    <DeskConfirm open title={/\?\s*$/.test(title) ? title : `${title} ?`} message={description} icon={XCircle} busy={saving} withReason reasonPlaceholder="Motif (obligatoire, 3 caractères min.)"
      confirmLabel={saving ? "…" : confirmLabel} onClose={() => { if (!saving) onClose?.(); }} onConfirm={submit} testId="avi-reason-modal" />
  );
}
